<div
  class="input-currency input-currency--{{ view }}"
  [ngClass]="{ 'input-currency--disabled': readonly || disabled }"
>
  <ng-container *ngIf="label">
    <label
      class="input-currency__label"
      [for]="name"
    >{{ label }}{{required ? '*' : ''}}</label>
  </ng-container>
  <div
    class="input-currency__control"
    [ngClass]="{
      'input-currency__control--success': success,
      'input-currency__control--error': error,
      'input-currency__control--focus': inputFocussed
    }"
  >
    <div class="input-currency__select">
      <div
        class="input-currency__selected"
        (click)="toggleOptions()"
      >
        <span class="selected__label">{{ selectedCurrency }}</span>
        <img
          class="selected__icon"
          mfpLazyImage
          lazySrc="assets/icons/arrow-small.svg"
          alt="Arrow icon for currency selection"
          [ngClass]="{ 'selected__icon--open': showOptions }"
        />
      </div>
      <ng-container *ngIf="showOptions">
        <ul class="select__options">
          <li
            *ngFor="let option of currencyOptions"
            class="select__option"
            (click)="selectOption(option)"
          >{{ option.key }}</li>
        </ul>
      </ng-container>
    </div>
    <input
      class="input-currency__input"
      autocomplete="off"
      type="text"
      [placeholder]="0 | configCurrency"
      [id]="name"
      [name]="name"
      [required]="required"
      [readonly]="readonly"
      [disabled]="disabled"
      [mask]="currencyConstraints?.masking?.mask || 'separator'"
      [thousandSeparator]="thousandSeparator"
      [decimalMarker]="decimalMarker"
      [ngModel]="amountStr"
      (ngModelChange)="setAmountStr($event)"
      (focus)="setFocus()"
      (blur)="loseFocus()"
    />
  </div>
  <ng-container *ngIf="helper">
    <p class="input-currency__helper">{{ helper }}</p>
  </ng-container>
</div>
